import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, ArmchairIcon, UtensilsIcon, ClockIcon, WalletIcon, SunriseIcon, SproutIcon } from 'lucide-react';
const days = [{
  day: 'Día 1',
  title: 'Ordena tu mente',
  text: 'Para sacar de tu cabeza todos esos pendientes que te causan estrés.',
  Icon: BrainIcon
}, {
  day: 'Día 2',
  title: 'Ordena tu espacio personal',
  text: 'Para recuperar un rincón de paz dentro de tu hogar.',
  Icon: ArmchairIcon
}, {
  day: 'Día 3',
  title: 'Ordena tu cocina y alimentación',
  text: 'Para simplificar comidas, compras y organización de cocina.',
  Icon: UtensilsIcon
}, {
  day: 'Día 4',
  title: 'Ordena tu tiempo',
  text: 'Para planear tu semana con más claridad y menos presión.',
  Icon: ClockIcon
}, {
  day: 'Día 5',
  title: 'Ordena tus finanzas básicas',
  text: 'Para mirar tu dinero con calma, sin vergüenza y con más control.',
  Icon: WalletIcon
}, {
  day: 'Día 6',
  title: 'Ordena tus rutinas',
  text: 'Para crear mañanas, noches y hábitos más tranquilos.',
  Icon: SunriseIcon
}, {
  day: 'Día 7',
  title: 'Ordena tu nueva vida',
  text: 'Para crear un plan de mantenimiento y continuar con más paz.',
  Icon: SproutIcon
}];
export function SevenDays() {
  return <section id="plan" className="w-full bg-cream px-5 py-20 sm:px-8 sm:py-28" data-id="element-130" data-mp="3s9ie3o6wqf94">
      <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="3mzxnc5ojm5">
        <header className="max-w-2xl" data-id="element-132" data-mp="2k5j5fmjz1h">
          <p className="text-[0.7rem] uppercase tracking-[0.22em] text-clay" data-id="element-133" data-mp="52pw0ia5rfhz">
            Qué encontrarás dentro
          </p>
          <h2 className="mt-4 font-serif text-4xl leading-tight text-ink sm:text-5xl" data-id="element-134" data-mp="9upyoihm4mi9">
            Un plan completo de 7 días
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-cocoa" data-id="element-135" data-mp="jsdrv3zkllyb">
            Cada día tiene un solo enfoque, con ejercicios cortos, preguntas de
            reflexión y checklists prácticas.
          </p>
        </header>

        <ol className="mt-14 space-y-0" data-id="element-136" data-mp="2kttvv24d0qu9">
          {days.map(({
          day,
          title,
          text,
          Icon
        }, index) => <motion.li key={day} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.05,
          ease: [0.22, 1, 0.36, 1]
        }} className="group grid grid-cols-[auto_1fr] gap-5 border-t border-sand py-7 last:border-b sm:grid-cols-[auto_9rem_1fr] sm:gap-8" data-id="element-137" data-mp="2fwblr8elw5ko" data-mpi={index}>
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-sand bg-linen text-terracotta transition-colors duration-300 group-hover:bg-terracotta group-hover:text-cream" data-id="element-138" data-mp="2yo4fj51i1utg">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-139" data-mp="1i7s0dooa68wu" />
              </span>
              <span className="col-span-2 -mt-1 font-serif text-2xl text-clay sm:col-span-1 sm:mt-1 sm:text-xl" data-id="element-140" data-mp="1i9upm6hlzy0i">
                {day}
              </span>
              <div className="col-span-2 sm:col-span-1" data-id="element-141" data-mp="143ax4l5q569u">
                <h3 className="font-serif text-2xl text-ink sm:text-3xl" data-id="element-142" data-mp="183tpcgbj4eck">{title}</h3>
                <p className="mt-2 text-base leading-relaxed text-cocoa" data-id="element-143" data-mp="185xut2p2tley">{text}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}